import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { scrollToTop } from '@/lib/scrollToTop'

/** Scroll window to top on route or query-string changes (e.g. Shop All ↔ Featured). */
export function ScrollToTop() {
  const { pathname, search, hash } = useLocation()

  useLayoutEffect(() => {
    scrollToTop()
  }, [pathname, search, hash])

  return null
}
